import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentExcel = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentExcel' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M9.25,12 L7.25,15.25 L5.25,12 L5,12 L7.25,15.5 L4.75,19 L5,19 L7.25,15.75 L9.5,19 L9.75,19 L7.25,15.5 L9.5,12 L9.25,12 Z' />
  </StyledIcon>
);
